import { render } from "./BanModal.vue?vue&type=template&id=3b716df4&scoped=true"
import script from "./BanModal.vue?vue&type=script&lang=js"
export * from "./BanModal.vue?vue&type=script&lang=js"

import "./BanModal.vue?vue&type=style&index=0&id=3b716df4&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-3b716df4"

export default script